import React from "react";
import { useTranslation } from "react-i18next";
import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SizePreferencesSection } from "./sections/SizePreferencesSection";
import { FavoriteBrandsSection } from "./sections/FavoriteBrandsSection";
import { usePreferences } from "./hooks/use-preferences";

export const PreferencesTab: React.FC = () => {
  const { t } = useTranslation();
  const { savePreferences, isSaving } = usePreferences();

  const handleSave = async () => {
    await savePreferences();
  };

  return (
    <div className="flex flex-col">
      {/* Header with Title */}
      <div className="flex flex-col gap-2 px-4 md:px-6 py-3 md:py-5 bg-bg-tertiary dark:bg-gray-800 border-b border-border-secondary dark:border-border-secondary">
        <h2 className="text-base md:text-xl font-semibold text-text-primary dark:text-text-primary">
          {t("preferences.title")}
        </h2>
        <p className="text-xs md:text-sm text-text-tertiary dark:text-text-tertiary">
          {t("preferences.description")}
        </p>
      </div>

      {/* Main Content */}
      <div className="flex flex-col gap-6 md:gap-8 px-4 md:px-6 py-4 md:py-6">
        {/* Size Preferences Section */}
        <SizePreferencesSection />

        {/* Divider */}
        <div className="h-px bg-border-secondary dark:bg-border-secondary" />

        {/* Favorite Brands Section */}
        <FavoriteBrandsSection />

        {/* Save Button */}
        <div className="flex items-center justify-end gap-3 pt-4 border-t border-border-secondary dark:border-border-secondary">
          <Button
            onClick={handleSave}
            disabled={isSaving}
            variant="darkPrimary"
            className="flex items-center gap-2 px-6 py-2 bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSaving ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                <span>{t("common.saving") || "Saving..."}</span>
              </>
            ) : (
              <>
                <Save className="w-4 h-4" />
                <span>{t("common.save")}</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};
